import { render, staticRenderFns } from "./CompensationTypeCreate.vue?vue&type=template&id=64b0b0c4&scoped=true&"
import script from "./CompensationTypeCreate.vue?vue&type=script&lang=js&"
export * from "./CompensationTypeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b0b0c4",
  null
  
)

export default component.exports